/**
 * CTA Split Template
 *
 * A split call-to-action section with text on the left and button on the right.
 */

// eslint-disable-next-line no-unused-vars
const ctaSplit = {
  id: 'cta-split',
  name: 'Split CTA',
  category: 'cta',
  description: 'Split call-to-action with text left and button right on dark background',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: '#1a1a1a',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '0',
    paddingTop: '64',
    paddingBottom: '64',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'cta-split-row-1',
        type: 'row',
        props: {
          direction: { base: 'horizontal', tablet: null, desktop: null },
          gap: 'lg',
          alignment: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          columnLayout: { base: 'custom', tablet: null, desktop: null },
          columnWidths: [],
          width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: '1200', unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: 'transparent',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 0,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: '',
        },
        children: [
          {
            id: 'cta-split-col-left',
            type: 'column',
            props: {
              gap: 'sm',
              alignItems: 'flex-start',
              justifyContent: 'center',
              span: { base: 8, tablet: null, desktop: null },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'cta-split-heading',
                type: 'text',
                props: {
                  content: 'Take Your Business Further',
                  element: 'h2',
                  fontFamily: 'System Default',
                  fontSize: 32,
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  letterSpacing: 0,
                  color: '#ffffff',
                  textAlign: 'left',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 8, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'cta-split-text',
                type: 'text',
                props: {
                  content: 'Get started with our platform today and see results within days.',
                  element: 'p',
                  fontFamily: 'System Default',
                  fontSize: 16,
                  fontWeight: 'normal',
                  lineHeight: 1.5,
                  letterSpacing: 0,
                  color: '#cccccc',
                  textAlign: 'left',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
            ],
          },
          {
            id: 'cta-split-col-right',
            type: 'column',
            props: {
              gap: 'md',
              alignItems: 'flex-end',
              justifyContent: 'center',
              span: { base: 4, tablet: null, desktop: null },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'cta-split-button',
                type: 'button',
                props: {
                  text: 'Get Started Now',
                  url: '',
                  openInNewTab: false,
                  variant: 'primary',
                  size: 'lg',
                  fullWidth: false,
                  backgroundColor: '#ffffff',
                  textColor: '#1a1a1a',
                  hoverBackgroundColor: '#e0e0e0',
                  fontFamily: 'System Default',
                  fontSize: 16,
                  fontWeight: '600',
                  padding: { base: { top: 14, bottom: 14, left: 28, right: 28, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 8,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default ctaSplit;
